import { render, staticRenderFns } from "./TV2.vue?vue&type=template&id=0cf61ee7&scoped=true"
import script from "./TV2.vue?vue&type=script&lang=js"
export * from "./TV2.vue?vue&type=script&lang=js"
import style0 from "./TV2.vue?vue&type=style&index=0&id=0cf61ee7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf61ee7",
  null
  
)

export default component.exports